import React from 'react'
import Card from '../../components/Card'
import { H1, H2, PageHeading } from '../../components/Headings'
import useLocale from '../../hooks/useLocale'
import useUserPoints from '../../hooks/useUserPoints'
import PointsCard from '../../components/PointsCard'
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import useModal from "../../hooks/useModal";
import { Input } from "../../components/FormComponents";
import CheckRole from "../../components/CheckRole";

function UserPointsPage () {
  const { l } = useLocale()
  const {showModal, openModal, closeModal} = useModal()
  const { points, addPoints } = useUserPoints()

  const pointsRef = React.useRef(null)
  const conceptRef = React.useRef(null)

  async function handleSubmit(e) {
    e.preventDefault()
    const points = pointsRef.current.value
    const concept = conceptRef.current.value
    await addPoints(points, concept)
    closeModal()
    pointsRef.current.value = ''
    conceptRef.current.value = ''
  }

  return (
    <>
      <PageHeading image={'/img/trohpy.svg'} title={l('view_points')}>
        <CheckRole has={"manage_points"}>
          <Button onClick={openModal}>{l('manage_points')}</Button>
        </CheckRole>
      </PageHeading>

      <Modal show={showModal} onClose={closeModal}>
        <H2>{l('add_points')}</H2>

        <p>{l('add_points_description')}</p>

        <form onSubmit={handleSubmit}>
          <Input label={l('points')} type='number' reference={pointsRef} placeholder={l('points')} className='mb-4' />
          <Input label={l('concept')} reference={conceptRef} defaultValue={"Ajuste manual de puntos"} className='mb-4' />

          <Button>{l('add_points')}</Button>
        </form>
      </Modal>

      <Card>
        <div className="grid grid-cols-3 mb-9 gap-3">
          <PointsCard>
            <strong>{l('total')}:</strong>
            <span>{points.totals.total?.toLocaleString('es-ES', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} pts</span>
          </PointsCard>
          <PointsCard type='gained'>
            <strong>{l('gained')}:</strong>
            <span>{points.totals.gained?.toLocaleString('es-ES', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} pts</span>
          </PointsCard>
          <PointsCard type='wasted'>
            <strong>{l('spent')}:</strong>
            <span>{points.totals.wasted?.toLocaleString('es-ES', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} pts</span>
          </PointsCard>
        </div>
        <table className="w-full">
          <thead className='text-left border-b border-gray-600'>
            <tr>
              <th>{l('concept')}</th>
              <th>{l('ammount')}</th>
            </tr>
          </thead>
          <tbody>
            {points.points.map(point => <tr key={point._id}>
              <td>{l(point.concept)}</td>
              <td>{point.points.toLocaleString('es-ES', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })} pts</td>
            </tr>)}
          </tbody>
        </table>
      </Card>
    </>
  )
}

export default UserPointsPage